import { useCallback, useEffect, useState } from "react";
import type { User } from "@packsize/identity-api-sdk";

export type UserEdit = Partial<User> & {
	password?: string;
	password2?: string;
	forcePasswordReset?: boolean;
};

const EMPTY_USER_EDIT: UserEdit = {};

export const useUserEdit = (initialUser: UserEdit = EMPTY_USER_EDIT) => {
	const [userEdit, setUserEdit] = useState<UserEdit>(initialUser);

	useEffect(() => {
		setUserEdit(initialUser);
	}, [initialUser]);

	const updateUserEdit = useCallback((updates: Partial<UserEdit>): void => {
		setUserEdit((currentUserEdit) => ({ ...currentUserEdit, ...updates }));
	}, []);

	return { userEdit, setUserEdit: updateUserEdit };
};
